import React, { useEffect, useState } from "react";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  DialogContentText,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { MdDeleteOutline } from "react-icons/md";
import { BsTrash3 } from "react-icons/bs";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { useTheme } from "../../../style/theme";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';

export default function ManageShifts() {
  const [addShiftModal, setAddShiftModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [shifts, setShifts] = useState([]);
  let currentOrg = JSON.parse(localStorage.getItem("org"));
  const { mode } = useTheme();
  const columns = ["Shift Name", "Shift Time", "Actions"];

  const fetchShifts = async () => {
    try {
      const response = await axios.get(
        `/hr/adminShift?orgId=${currentOrg?._id}`
      );
      setShifts(response.data.data);
    } catch (error) {
      console.error("Error fetching requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShifts();
  }, []);

  const { handleSubmit, control, watch, setValue, reset } = useForm();

  function convertTo12HourFormat(time24) {
    const [hour, minute] = time24.split(":");
    const hourNum = parseInt(hour);
    const ampm = hourNum >= 12 ? "PM" : "AM";
    const hour12 = hourNum % 12 || 12; // 0 => 12
    return `${String(hour12).padStart(2, "0")}:${minute} ${ampm}`;
  }

  const onSubmit = async (data) => {
    let adminId = currentOrg?._id;
    const fromFormatted = convertTo12HourFormat(data?.workedTimeFrom);
    const toFormatted = convertTo12HourFormat(data?.workedTimeTo);
    try {
      const payload = {
        adminId: adminId,
        shiftName: data?.shiftName,
        workedTime: {
          from: fromFormatted, // e.g., 09:00 AM
          to: toFormatted, // e.g., 05:30 PM
        },
      };

      await axios.post("/hr/adminShift", payload);

      setAddShiftModal(false);
      fetchShifts();
    } catch (error) {
      console.error("Submit error:", error);
    }
  };


  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const handleOpenModal = (id) => {
    setSelectedRowId(id);
    setOpenDelete(true);
  };

  const handleClose = () => {
    setOpenDelete(false);
    setSelectedRowId(null);
  };



  // DELETE handler
  const handleDelete = async (id) => {
    if (!id) return;
    try {
      await axios.delete(`/hr/adminShift/${id}`);

      fetchShifts();
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  const handleConfirmDelete = () => {
    handleDelete(selectedRowId);
    handleClose();
  };
  return (
    <div className="w-full  flex flex-col items-center gap-1 mt-4">
      <div className="w-full flex justify-end items-center">
        <Button
          onClick={() => {
            setAddShiftModal(true);
          }}
          variant="contained"
        >
          Add Shift
        </Button>
      </div>
      <div className="w-full">
        <TableContainer style={{ marginTop: "8px" }}>
          <Table>
            <TableHead>
              <TableRow>
                {columns?.map((column, index) => (
                  <TableCell key={index} style={{ whiteSpace: "nowrap" }}>
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {shifts?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row?.shiftName}</TableCell>
                  <TableCell>
                    {row?.workedTime?.from} - {row?.workedTime?.to}
                  </TableCell>
                  <TableCell>
                    <BsTrash3
                      style={{ cursor: "pointer", color: "red" }}
                      onClick={() => handleOpenModal(row?._id)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Confirmation Dialog */}
        <Dialog open={openDelete} onClose={handleClose}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this shift?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirmDelete} color="error" variant="contained">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          open={addShiftModal}
          onClose={() => setAddShiftModal(false)}
          fullWidth
          maxWidth="sm"
        >
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="h-full flex flex-col"
          >
            <DialogTitle>Assign Shift</DialogTitle>

            <DialogContent>
              <Grid container spacing={2} direction="column">
                {/* Shift Name */}
                <Grid item>
                  <Controller
                    name="shiftName"
                    control={control}
                    render={({ field }) => (
                      <TextField fullWidth multiline rows={1} {...field} />
                    )}
                  />
                </Grid>

                {/* Time Inputs */}
                <Grid item>
                  <div className="flex gap-2">
                    {/* FROM TIME */}
                    <Controller
                      name="workedTimeFrom"
                      control={control}
                      render={({ field }) => (
                        <TimePicker
                          {...field}
                          onChange={field.onChange}
                          value={field.value}
                          disableClock={true}
                          format="h:mm a"
                        />
                      )}
                    />

                    {/* TO TIME */}
                    <Controller
                      name="workedTimeTo"
                      control={control}
                      render={({ field }) => (
                        <TimePicker
                          {...field}
                          onChange={field.onChange}
                          value={field.value}
                          disableClock={true}
                          format="h:mm a"
                        />
                      )}
                    />
                  </div>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                sx={{ backgroundColor: "#0088ff" }}
              >
                Submit
              </Button>
              <button
                style={{
                  backgroundColor: mode === "light" ? "#fff" : "#0088ff",
                }}
                className="w-[79px] h-[36px] rounded-md"
                onClick={() => setAddShiftModal(false)}
              >
                Cancel
              </button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    </div>
  );
}
